module.exports = new __parcel__URL__("list-merge-modal-light.8f13cf58.gif").toString();